export default "__VITE_ASSET__5bxSXytf__"